import React, { useState } from 'react';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { getStripe } from '../lib/stripeClient';

/**
 * Collects a card via Stripe Elements and confirms it against the
 * SetupIntent the backend already created for this customer (see
 * customers.js / customerService.js). The card number is typed directly
 * into Stripe's iframe and tokenized in the browser -- it never passes
 * through our server, which is what keeps this tool at PCI SAQ A instead
 * of requiring full PCI scope on csr-server.
 */
function CardForm({ clientSecret, billingDetails, onConfirmed }) {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [confirming, setConfirming] = useState(false);

  async function handleSave(e) {
    e.preventDefault();
    if (!stripe || !elements) return;
    setConfirming(true);
    setError(null);

    const { error: stripeError, setupIntent } = await stripe.confirmCardSetup(clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement),
        billing_details: billingDetails,
      },
    });

    setConfirming(false);
    if (stripeError) {
      setError(stripeError.message);
      return;
    }
    onConfirmed(setupIntent.payment_method);
  }

  return (
    <form onSubmit={handleSave}>
      {error && <div className="error-banner">{error}</div>}
      <label>Card details</label>
      <div className="card-element-box">
        <CardElement options={{ style: { base: { fontSize: '16px' } } }} />
      </div>
      <p className="hint-text">
        Card details go directly from this browser to Stripe and never touch our server.
      </p>
      <button type="submit" className="btn btn-primary" style={{ marginTop: 12 }} disabled={!stripe || confirming}>
        {confirming ? 'Saving card…' : 'Save card & continue'}
      </button>
    </form>
  );
}

export default function CardSetup({ clientSecret, billingDetails, onConfirmed }) {
  if (!clientSecret) return null;
  return (
    <Elements stripe={getStripe()}>
      <CardForm clientSecret={clientSecret} billingDetails={billingDetails} onConfirmed={onConfirmed} />
    </Elements>
  );
}
